import * as React from 'react';

const FacebookIcon = ({ size = 20, color = '#2B52D4' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10.7392C20 5.18059 15.5206 0.677246 10 0.677246C4.47563 0.677246 0 5.18059 0 10.7392C0 15.7601 3.65562 19.9232 8.4375 20.6772V13.6483H5.89813V10.7398H8.4375V8.52179C8.4375 6.00064 9.92813 4.60832 12.2131 4.60832C13.3075 4.60832 14.4531 4.80453 14.4531 4.80453V7.2804H13.19C11.95 7.2804 11.5625 8.05705 11.5625 8.85258V10.7392H14.3356L13.89 13.6477H11.5625V20.6766C16.3406 19.9226 20 15.7595 20 10.7386V10.7392Z"
        fill={color}
      />
    </svg>
  );
};

export default FacebookIcon;
